<template>
    <div class="soft-competences-wrapper">
        <SoftCompetencesEmpty v-if="!getSoftCompetences.length"/>
        <div class="content" v-else>
            <div class="main-content">
                <div class="titles">
                    <div
                        class="title"
                        v-for="(item, index) in getCompetenceLevels"
                        :key="index"
                    >{{item.name}}</div>
                </div>
                <Slider
                    class="slider"
                    :itemWidth="129"
                    :itemsCount="getSoftCompetences.length"
                >
                    <SoftCompetences
                        :competences="getSoftCompetences"
                    />
                </Slider>
            </div>

            <div class="legend">
                <div class="description">Пройдите
                    <router-link
                        :to="{ name: 'account-competences' }"
                        class="link"
                    >тестирование</router-link>
                    , чтобы оценить свои компетенции
                </div>
                <div class="bullet-legend">
                    <div class="default item">
                        <div class="icon"></div>
                        <div class="text">Исходный уровень</div>
                    </div>
                    <div class="target item">
                        <div class="icon"></div>
                        <div class="text">Целевой уровень</div>
                    </div>
                    <div class="completed item">
                        <div class="icon"></div>
                        <div class="text">Цель достигнута</div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import SoftCompetences from './SoftCompetences';
import SoftCompetencesEmpty from './SoftCompetencesEmpty';

const trackGetters = [
    'getSoftCompetences',
    'getCompetenceLevels',
];

import Slider from '../Slider';

export default {
    name: 'SoftCompetencesWrapper',
    components: {
        Slider,
        SoftCompetences,
        SoftCompetencesEmpty,
    },
    data: ()=>({}),
    computed: {
        ...mapGetters('accountTrack', trackGetters),
    },
};
</script>

<style lang="scss" scoped>
@import "~@/styles/rem";

.soft-competences-wrapper{
    padding: 24px 24px 0;

    .main-content{
        display: flex;
        flex-direction: row;
        .titles{
            width: 100px;
            margin-top: 90px;
            font-style: normal;
            font-weight: 600;
            font-size: 14px;
            line-height: 20px;
            color: #98A0A9;
            .title{
                height: 48px;
            }
        }
        .slider{
            flex: 1;
        }
    }

    .legend{
        display: flex;
        flex-flow: row wrap;
        margin-top: 16px;

        .description{
            flex: 1;
            font-style: normal;
            font-weight: normal;
            font-size: 16px;
            line-height: 24px;
            color: #2A2626;
            white-space: nowrap;
            margin: 0 16px 24px 0;

            .link{
                color: #4663AB;

                &:hover {
                    color: #356ED4;
                }
            }
        }
        .bullet-legend{
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            margin: 0 0 24px 0;

            .item{
                font-weight: 600;
                font-size: 14px;
                line-height: 20px;
                color: #98A0A9;
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: center;
                margin: 0 24px 0 0;

                &:last-of-type {
                    margin: 0;
                }

                .icon{
                    width: 25px;
                    height: 25px;
                    border-radius: 50%;
                    background-size: 220% 220%;
                    background-position: center center;
                    background-repeat: no-repeat;
                }
                .text{
                    margin-left: 7px;
                }
            }
            .default {
                .icon{
                    background-image: url("~@/assets/images/account-track/icon/competences/competence-default.svg");
                }
            }
            .target {
                .icon{
                    background-size: 100% 100%;
                    background-image: url("~@/assets/images/account-track/icon/competences/flag.svg");
                }
            }
            .completed {
                .icon{
                    background-image: url("~@/assets/images/account-track/icon/competences/competence-complete.svg");
                }
            }
        }
    }
}
</style>